import type { Editor } from '@tiptap/react';
import React, { useEffect } from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Image from '@tiptap/extension-image';
import { Button, ButtonIcon } from '../../../../components';

const MenuBar = ({ editor }: { editor: Editor | null }) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 border-b pb-2 mb-2">
      <ButtonIcon icon={'FormatBold'} onClick={() => editor.chain().focus().toggleBold().run()} isOutline={!editor.isActive('bold')}/>
      <ButtonIcon icon={'FormatItalic'} onClick={() => editor.chain().focus().toggleItalic().run()} isOutline={!editor.isActive('italic')} />
      <ButtonIcon icon={'FormatUnderlined'} onClick={() => editor.chain().focus().toggleUnderline().run()} isOutline={!editor.isActive('underline')} />
      <ButtonIcon icon={'FormatStrikethrough'}  onClick={() => editor.chain().focus().toggleStrike().run()} isOutline={!editor.isActive('strike')} />
      <ButtonIcon icon={'FormatAlignLeft'} onClick={() => editor.chain().focus().setTextAlign('left').run()} isOutline={!editor.isActive({ textAlign: 'left' })} />
      <ButtonIcon icon={'FormatAlignCenter'} onClick={() => editor.chain().focus().setTextAlign('center').run()} isOutline={!editor.isActive({ textAlign: 'center' })} />
      <ButtonIcon icon={'FormatAlignRight'} onClick={() => editor.chain().focus().setTextAlign('right').run()} isOutline={!editor.isActive({ textAlign: 'right' })} />
    </div>
  );
};

const ImpactReportEditor = ({ content, send, status = 'idle' }: { content: string | null, send: (data: any) => void, status: 'idle' | 'sending' | 'sent' }) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: { levels: [ 1, 2 ] },
      }),
      Image,
      Underline,
      Link,
      Highlight,
      TextAlign.configure({ types: [ 'heading', 'paragraph' ] }),
    ],
    content: '<p>Start typing here...</p>',
  });

  useEffect(() => {
    console.log('Content changed:', content);
    if (editor && content) {
      editor.commands.setContent(content);
    }
  }, [ content, editor ]);

  const sendImpactReport = () => {
    if (editor) {
      const htmlContent = editor.getHTML();
      send({ data: { content: htmlContent } });
    }
  };

  const buttonLabel = status === 'idle' ? 'Send Impact Report' : (status === 'sending' ? 'Sending...' : 'Sent');

  return (
    <div className={'w-full mx-auto p-4 border rounded-md shadow space-y-4'}>
      <MenuBar editor={editor} />
      <EditorContent editor={editor} className="ProseMirror border p-2 rounded" />
      <div className={'flex justify-center'}>
        <Button
          type={'submit'}
          color={'positive'}
          className={'w-1/3'}
          disabled={[ 'sending', 'sent' ].includes(status)}
          onClick={sendImpactReport}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

export { ImpactReportEditor };
